<template>
  <main v-if="!loading" class="watchlist">
    <div class="main__container">
      <div class="page__header">
        <h1 class="page__title">{{ $route.params.page === 'movies' ? $t('mediaPage.titleMovies') :
          $t('mediaPage.titleSeries') }}</h1>
      </div>
      <div class="page__content">
        <MediaMovieList :movieByCategory="mediaData" />
      </div>
    </div>
  </main>
  <MainPreloader v-else />
</template>

<script setup>

import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import MainPreloader from '@/components/ui/MainPreloader.vue';
import MediaMovieList from '@/modules/media/MediaMovieList.vue'
import { i18nRoute } from '@/utils/useTranslate';

const store = useStore()
const route = useRoute()
const router = useRouter()
const loading = computed(() => store.state.media.mediaData.loading)
const mediaData = computed(() => store.state.media.mediaData.data)

const loadMedia = () => {
  if (route.params.page === 'series' || route.params.page === 'movies') {
    store.dispatch('media/getMediaData', route.params.page === 'series' ? 'tv' : 'movie');
  } else {
    router.push(i18nRoute({ name: 'home page' }))
  }
}

// watch(() => route.params.page, () => loadMedia())

watch([route], () => {
  store.dispatch('media/getMediaData', route.params.page === 'series' ? 'tv' : 'movie')
})

loadMedia()

</script>

<style lang="scss" scoped>
.main__container {
  padding-top: rem(80);

  @include media-breakpoint-down(xs) {
    padding-top: rem(40);
  }
}
</style>
